import { render, staticRenderFns } from "./CustomCheckboxV2.vue?vue&type=template&id=6a5fed67&scoped=true"
import script from "./CustomCheckboxV2.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxV2.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckboxV2.vue?vue&type=style&index=0&id=6a5fed67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5fed67",
  null
  
)

export default component.exports